import { oidcEarlyInit } from "oidc-spa/entrypoint";

const { shouldLoadApp } = oidcEarlyInit({ BASE_URL: import.meta.env.BASE_URL });

if (shouldLoadApp) {
  import("./main.lazy");
}
